import React from 'react';
import { Share2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Property } from '@/types/schema';

interface ShareButtonProps {
  property: Property;
  className?: string;
  showText?: boolean;
}

const ShareButton: React.FC<ShareButtonProps> = ({ 
  property, 
  className = '', 
  showText = false 
}) => {
  
  const handleShare = () => {
    // Dispatch custom event to trigger share modal
    document.dispatchEvent(new CustomEvent('share:property', { 
      detail: { property } 
    }));
  };

  return (
    <Button
      variant="outline"
      size={showText ? "default" : "icon"}
      className={`${className} hover:text-global-cyan hover:border-global-cyan`}
      onClick={handleShare}
      title="Immobilie teilen"
    >
      <Share2 className={`${showText ? 'mr-2' : ''} h-5 w-5`} />
      {showText && "Immobilie teilen"}
    </Button>
  );
};

export default ShareButton;
